import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { from } from 'rxjs';

import { AccountService } from 'src/app/core/services/account.service';
import { ErrorService } from 'src/app/core/services/error.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { SpinnerService } from 'src/app/core/services/spinner.service';

@Component({
  selector: 'app-account-edit',
  templateUrl: './account-edit.component.html',
  styleUrls: ['./account-edit.component.css'],
})
export class AccountEditComponent implements OnInit {
  emailForm: FormGroup;
  profileEmail = this.profileService.me.email;

  constructor(
    private formBuilder: FormBuilder,
    private profileService: ProfileService,
    private accountService: AccountService,
    private spinnerService: SpinnerService,
    private toastrService: ToastrService,
    private errorService: ErrorService
  ) {}

  ngOnInit(): void {
    this.prepareEmailForm();
  }

  prepareEmailForm(): void {
    this.emailForm = this.formBuilder.group({
      email: [
        this.profileService.me.email,
        [
          Validators.required,
          Validators.pattern(
            '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,10}$'
          ),
        ],
      ],
    });
  }

  onSubmitEmail() {
    if (this.emailForm.valid) {
      this.spinnerService.show();
      from(this.accountService.changeEmail(this.emailForm.get('email').value))
        .pipe(finalize(() => this.spinnerService.hide()))
        .subscribe({
          next: (res) => {
            this.profileService.me.email = res.email;

            this.toastrService.success(
              $localize`:@@settings_editAccount_emailSuccessDescription:Your mail is well modified`,
              $localize`:@@settings_editAccount_SuccessTitle:Congratulations`
            );
          },
          error: (err) => {
            if (err == 'Error: conflict') {
              this.errorService.addError(
                $localize`:@@settings_editAccount_emailConflictErrorDescription:This mail is already used`,
                $localize`:@@settings_editAccount_ErrorTitle:We are sorry`
              );
            } else {
              this.errorService.addError(
                $localize`:@@settings_editAccount_ErrorDescription:A problem is occured, please retry later`,
                $localize`:@@settings_editAccount_ErrorTitle:We are sorry`
              );
            }
            this.errorService.show();
          },
        });
    }
  }

  setPassword(createPasswordForm: FormGroup) {
    this.onSubmitPwd(
      createPasswordForm.get('currentPwd').value,
      createPasswordForm.get('password').value
    );
  }

  onSubmitPwd(currentPwd, newPassword) {
    if (currentPwd !== newPassword) {
      this.spinnerService.show();
      from(this.accountService.changePassword(currentPwd, newPassword))
        .pipe(finalize(() => this.spinnerService.hide()))
        .subscribe({
          next: (res) => {
            this.toastrService.success(
              $localize`:@@authentication_resetPasswordFormFilled_toastSuccessMessage:Your password is well modified`,
              $localize`:@@settings_editAccount_SuccessTitle:Congratulations`
            );
          },
          error: (err) => {
            if (err == 'Error: badrequest') {
              this.errorService.addError(
                $localize`:@@settings_editAccount_passwordErrorDescription:Your password is not correct, please retry`,
                $localize`:@@settings_editAccount_ErrorTitle:We are sorry`
              );
            } else {
              this.errorService.addError(
                $localize`:@@settings_editAccount_ErrorDescription:A problem has occured, please retry later`,
                $localize`:@@settings_editAccount_ErrorTitle:We are sorry`
              );
            }
            this.errorService.show();
          },
        });
    } else {
      this.errorService.addError(
        $localize`:@@settings_editAccount_passwordSameError:Your new password must be different from the last one`,
        $localize`:@@settings_editAccount_ErrorTitle:We are sorry`
      );
      this.errorService.show();
    }
  }
}
